export default __webpack_public_path__ + "static/media/slide2_m_bg.9fcf0986.png";